import type { Bar, BarTimeframe, QuoteRow } from './market-types.js';
import type { HaltStatusResponse } from './halt-types.js';
import type { OrderBookSnapshot, PortfolioSnapshot, PositionSnapshot, SubmitOrderRequest, SubmitOrderResponse } from './trading-types.js';

export const API_ROUTES = {
  account: '/.netlify/functions/account',
  createCheckoutSession: '/.netlify/functions/create-checkout-session',
  createPortalSession: '/.netlify/functions/create-portal-session',
  startSignupCheckout: '/.netlify/functions/start-signup-checkout',
  completeSignup: '/.netlify/functions/complete-signup',
  stripeWebhook: '/.netlify/functions/stripe-webhook',
  bars: '/.netlify/functions/bars',
  clock: '/.netlify/functions/clock',
  scanner: '/.netlify/functions/scanner',
  news: '/.netlify/functions/news',
  halt: '/.netlify/functions/halt',
  orderbook: '/.netlify/functions/orderbook',
  orders: '/.netlify/functions/orders',
  positions: '/.netlify/functions/positions',
  portfolio: '/.netlify/functions/portfolio',
  schwabAuth: '/.netlify/functions/schwab-auth',
  ibAuth: '/.netlify/functions/ib-auth',
  brokerAuth: '/.netlify/functions/broker-auth',
} as const;

export type {
  NewsResponse,
} from './news-types.js';

export type {
  AccountResponse,
  CheckoutSessionResponse,
  PortalSessionResponse,
} from './account-types.js';

export type {
  HaltStatusResponse,
} from './halt-types.js';

export type {
  OrderBookSnapshot,
  PortfolioSnapshot,
  PositionSnapshot,
  SubmitOrderRequest,
  SubmitOrderResponse,
};

export interface SnapshotsResponse {
  quotes: QuoteRow[];
}

export interface BarsQuery {
  symbol: string;
  timeframe?: BarTimeframe;
  limit?: number;
  start?: string;
  end?: string;
}

export interface BarsResponse {
  symbol: string;
  timeframe: BarTimeframe;
  bars: Bar[];
}

export interface ClockResponse {
  isOpen: boolean;
  nextOpen: string | null;
  nextClose: string | null;
  timestamp: string;
}

export interface ApiError {
  error: string;
}
